import JoinCTA from '@/components/shared/JoinCTA';
import type React from 'react';
import { type HTMLAttributes, useContext, useEffect, useState } from 'react';
import { useInView } from 'react-intersection-observer';
import { PRODUCT_CAR } from '../../utils/products';
import { CarPageContext } from './CarPageContext';

const CTA: React.FC<
  React.PropsWithChildren<
    HTMLAttributes<HTMLAnchorElement> & {
      customUrl?: string;
    }
  >
> = ({ children = 'Check our prices', customUrl, ...props }) => {
  const { registerMainCta, setIsMainCtaVisible } = useContext(CarPageContext);
  const { ref, entry } = useInView();
  const [uuid] = useState<string>(String(Math.random()));

  useEffect(() => {
    registerMainCta(uuid, false);
  }, [registerMainCta, uuid]);

  useEffect(() => {
    if (!entry) return;

    setIsMainCtaVisible(uuid, entry?.isIntersecting);
  }, [entry, setIsMainCtaVisible, uuid]);

  return (
    <JoinCTA
      ref={ref}
      size="big"
      flavor="primary"
      id="gtm_button_car_check_prices"
      glowing
      data-source="car"
      product={PRODUCT_CAR}
      minWidth={233}
      analyticsParams={{ position: 'center' }}
      customUrl={customUrl}
      {...props}
    >
      {children}
    </JoinCTA>
  );
};

export default CTA;
